// Accent palettes for the runtime theme switcher.
// Colors are stored as comma-separated RGB triplets so they can be used
// in both rgb(var(--x)) and rgba(var(--x), alpha) expressions.

const STORAGE_KEY = "mth-accent";

export const accents = [
    {
        id: "emerald",
        label: "Emerald",
        a1: "16, 185, 129",
        a1l: "52, 211, 153",
        a1d: "5, 150, 105",
        a2: "34, 211, 238",
        a2l: "103, 232, 249",
        a2d: "8, 145, 178",
        a3: "110, 231, 183",
    },
    {
        id: "sunset",
        label: "Sunset",
        a1: "245, 158, 11",
        a1l: "251, 191, 36",
        a1d: "217, 119, 6",
        a2: "249, 115, 22",
        a2l: "251, 146, 60",
        a2d: "234, 88, 12",
        a3: "251, 113, 133",
    },
    {
        id: "ocean",
        label: "Ocean",
        a1: "59, 130, 246",
        a1l: "96, 165, 250",
        a1d: "37, 99, 235",
        a2: "34, 211, 238",
        a2l: "103, 232, 249",
        a2d: "8, 145, 178",
        a3: "56, 189, 248",
    },
    {
        id: "crimson",
        label: "Crimson",
        a1: "244, 63, 94",
        a1l: "251, 113, 133",
        a1d: "225, 29, 72",
        a2: "251, 191, 36",
        a2l: "252, 211, 77",
        a2d: "217, 119, 6",
        a3: "251, 146, 60",
    },
    {
        id: "lime",
        label: "Lime",
        a1: "132, 204, 22",
        a1l: "163, 230, 53",
        a1d: "101, 163, 13",
        a2: "34, 211, 238",
        a2l: "103, 232, 249",
        a2d: "8, 145, 178",
        a3: "74, 222, 128",
    },
    {
        id: "violet",
        label: "Violet",
        a1: "139, 92, 246",
        a1l: "167, 139, 250",
        a1d: "124, 58, 237",
        a2: "34, 211, 238",
        a2l: "103, 232, 249",
        a2d: "8, 145, 178",
        a3: "232, 121, 249",
    },
];

export const defaultAccent = accents[0];

export const accentToHex = (triplet) => {
    const channels = triplet.split(",").map((v) => parseInt(v.trim(), 10));
    return `#${channels.map((v) => v.toString(16).padStart(2, "0")).join("")}`;
};

export const applyAccent = (accent) => {
    const style = document.documentElement.style;
    style.setProperty("--accent-1", accent.a1);
    style.setProperty("--accent-1-light", accent.a1l);
    style.setProperty("--accent-1-dark", accent.a1d);
    style.setProperty("--accent-2", accent.a2);
    style.setProperty("--accent-2-light", accent.a2l);
    style.setProperty("--accent-2-dark", accent.a2d);
    style.setProperty("--accent-3", accent.a3);
};

export const getStoredAccent = () => {
    try {
        const id = window.localStorage.getItem(STORAGE_KEY);
        return accents.find((a) => a.id === id) || defaultAccent;
    } catch (e) {
        return defaultAccent;
    }
};

export const storeAccent = (accent) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, accent.id);
    } catch (e) {
        // storage unavailable (private mode) — ignore
    }
};
